export async function registerApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, clientAddress, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for registerApp operation.');
    }
    const toRegisterAppCallData = appRegistryDapp.registry.interface.encodeFunctionData('registerApp', [appAddress, clientAddress]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.registry.address],
        callData: [toRegisterAppCallData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
